



















































































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import { focus, willChange } from '@shared/ui/utilities/directives';

export default defineComponent({
  name: 'BaseInput',
  directives: {
    focus,
    willChange,
  },
  components: { BaseIcon, BaseButton },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    icon: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    valid: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
      description: 'Native input required attribute',
    },
    disabled: {
      type: Boolean,
      default: false,
      description: 'Native input disabled attribute',
    },
    hasShowPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPasswordVisible: false,
      inputType: '',
      isNumberTypeSafari: false,
    };
  },
  computed: {
    listeners(): any {
      return {
        ...this.$listeners,
        // @ts-ignore migrated from ui-library
        input: (event) => this.$emit('input', event.target.value, event),
      };
    },
    isPassword(): any {
      return this.type === 'password' && this.hasShowPassword;
    },
    idWithoutWhitespace(): any {
      return this.name.replace(/\s/g, '');
    },
  },
  watch: {
    type: {
      immediate: true,
      handler: function (type) {
        let inputType = type;
        // Safari has bug for number input
        if (typeof window !== 'undefined' || typeof document !== 'undefined') {
          const ua = navigator.userAgent.toLocaleLowerCase();
          if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && type === 'number') {
            this.isNumberTypeSafari = true;
            inputType = 'text';
          }
        }
        this.inputType = inputType;
      },
    },
    value: {
      immediate: true,
      handler: function (value) {
        if (!this.isNumberTypeSafari) return;
        if (isNaN(value)) {
          this.$emit('input');
        }
      },
    },
  },
  methods: {
    switchVisibilityPassword() {
      if (this.type !== 'password') return;
      this.isPasswordVisible = !this.isPasswordVisible;
      this.inputType = this.isPasswordVisible ? 'text' : 'password';
    },
  },
});
